import { useCartFetchStore } from '@/stores/cartFetchStore';
import type { ReloadOptions } from '@inertiajs/core';
import { useEffect, useRef } from 'react';

export function useReloadOnBack(options: ReloadOptions = {}): void {
    const isFirstLoad = useRef(true);

    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent): void => {
            if (isFirstLoad.current) {
                isFirstLoad.current = false;
                return;
            }

            useCartFetchStore.getState().fetchCart().then();
            if (typeof window !== 'undefined' && window.Alpine) {
                window.Alpine.store('cart').update();
            }
        };

        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, []);
}
